import type { User, UserOriginNetwork, YammerState } from '../../state/types';

type GetUserOriginNetworkBadge = (state: YammerState, userId: User['id']) => string | undefined;
export const getUserOriginNetworkBadge: GetUserOriginNetworkBadge = (state, userId) =>
  state.userOriginNetworks?.fulfilled?.byId[userId]?.badge;

type GetUserOriginNetworkId = (state: YammerState, userId: User['id']) => string | undefined;
export const getUserOriginNetworkId: GetUserOriginNetworkId = (state, userId) =>
  state.userOriginNetworks?.fulfilled?.byId[userId]?.originNetworkId;

type GetFulfilledUsersOriginNetwork = (state: YammerState) => Record<string, UserOriginNetwork>;
export const getFulfilledUsersOriginNetwork: GetFulfilledUsersOriginNetwork = (state) =>
  state.userOriginNetworks?.fulfilled?.byId;
